import { AxiosError } from 'axios';
import { AnnouncementDetail } from 'web-library/models/Announcements';
import { GET_ANNOUNCEMENT_NOTICE_DETAILS_URL } from 'web-library/constants/apiUrls';
import { GET_ANNOUNCEMENT_NOTICE_DETAILS_QUERY_KEY } from 'web-library/constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: AnnouncementDetail) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  announcementType: string;
  announcementUuid: string;
  enabled: boolean;
}

export const useGetAnnouncementNoticeDetails = ({
  onSuccess,
  onError,
  announcementType,
  announcementUuid,
  enabled,
}: Input) => {
  const getAnnouncementNoticeDetails = async () => {
    const res = await axiosClient.get<AnnouncementDetail>(
      GET_ANNOUNCEMENT_NOTICE_DETAILS_URL(announcementType, announcementUuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_ANNOUNCEMENT_NOTICE_DETAILS_QUERY_KEY, announcementUuid],
    getAnnouncementNoticeDetails,
    {
      onSuccess,
      onError,
      enabled,
    }
  );
};
